function helperStringSubstring (str, start, end) {
  return str.substring(start, end)
}

module.exports = helperStringSubstring



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperStringSubstring.js
// module id = 312
// module chunks = 98